<template>
<div class="wrapper-box">
    <div>
        <div class="box-page" v-if="!isShowDetail" key="tran1">
            <div class="page-header">
                <div class="d-flex align-items-center justify-content-center">
                    <span class="page-title">สมาชิกใหม่</span>
                    <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
                </div>
                <div class="right-of-header">
                    <div class="d-flex">
                        <div class="ele-search2">
                            <i class="fa fa-search"></i>
                            <input type="text" name="search" placeholder="ค้นหาชื่อและเบอร์โทร" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content">
                <div class="w-100" style="overflow-x: auto;">
                    <table id="tb_datalist" class="table table-hover">
                        <thead>
                            <tr>
                                <th style="width:170px;min-width: 170px">
                                </th>
                                <th style="width:70px;">
                                    <div class="text-btn header-text text-center">
                                        <span>ลำดับ</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="text-btn header-text">
                                        <span>วันที่สมัคร</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="text-btn header-text">
                                        <span>เวลาสมัคร</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="text-btn header-text">
                                        <span>ประเภท</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="text-btn header-text">
                                        <span>ในนาม</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="text-btn header-text">
                                        <span>ชื่อ</span>
                                    </div>
                                </th>
                                <th style="width: 180px;">
                                    <div class="text-btn header-text text-left">
                                        <span>เบอร์โทร</span>
                                        <!-- <i class="fa fa-chevron-down grey"></i> -->
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in listMember" :key="idx">
                                <td class="align-middle">
                                    <div class="show-on-hover">
                                        <div class="btn-group">
                                            <a href="#" class="btn btn-table" @click="showDetail(item.id)">รายละเอียด</a>
                                        </div>
                                        <div class="btn-group">
                                            <a data-toggle="dropdown" href="">
                                                <img height="24" :src="'../../goobank_assets/common/img/icons/threedots.png'" />
                                            </a>
                                            <div class="dropdown-menu">
                                                <a href="#" class="dropdown-item" @click="verifyRegister(item.id)">ยืนยันการสมัคร</a>
                                                <a href="#" class="dropdown-item" @click="rejectRegister(item.id)">ไม่ผ่านการสมัคร</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span v-text="getRowNo(idx + 1)"></span>
                                </td>
                                <td>
                                    <span v-text="item.created_at_text"></span>
                                </td>
                                <td>
                                    <span v-text="item.created_at_time_text"></span>
                                </td>
                                <td>
                                    <span v-text="item.member_type"></span>
                                </td>
                                <td>
                                    <span v-text="item.register_as_text"></span>
                                </td>
                                <td>
                                    <span v-text="item.member_name"></span>
                                </td>
                                <td>
                                    <span v-text="item.telephone"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
                </div>
            </div>
        </div>
        <member-detail v-if="isShowDetail" ref="memberDetail"
        :base-url="baseUrl" :storagePath="storagePath"
        @hideDetail="hideMemberDetail" key="tran2"></member-detail>
    </div>

    <div class="modal-group">
        <div id="modal_reject_new_member_reason" class="modal fade">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <div class="d-flex w-100 justify-content-between">
                            <div>
                                <h4 class="modal-title">ไม่ผ่านเพราะ...</h4>
                            </div>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="icon-close"></i>
                            </span>
                        </button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="container">
                            <div class="mb-2">เลือกเหตุผลในการไม่อนุมัติการสมัคร</div>
                            <select v-model="reason" class="form-control">
                                <option>อายุไม่ถึง 20 ปี บริบูรณ์ หรือ วัน/เดือน/ปีเกิด ไม่ตรงกับบัตรประชาชน</option>
                                <option>ที่อยู่ที่กรอกไม่ตรงกับบัตรประชาชน</option>
                                <option>กรองข้อมูล ชื่อ-นามสกุล เป็นภาษาอื่นที่ไม่ใช่ภาษาไทย</option>
                                <option>รูปภาพ "บัตรประชาชนตัวจริง" ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                                <option>รูปภาพ "สมุดบัญชี" ไม่ถูกต้อง ไม่ใช่ของผู้สมัคร หรือไม่ชัดเจน</option>
                                <option>รูปภาพที่ต้องอัพโหลดทั้ง 4 ภาพ ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                                <option>ข้อมูลผู้สมัครมีอยู่แล้วในระบบ</option>
                                <option>ข้อมูลในบางช่องตกหล่น หรือไม่ได้กรอกมา</option>
                                <option>รูปตัวเองคู่บัตรประชาชน ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                                <option>รูปถ่ายสลิปค่าสมัคร 100 บาท” ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                            </select>
                        </div>
                    </div>

                    <input type="hidden" v-model="reason_id" />
                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <div>
                            <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                            <button type="button" class="btn btn-small btn-ok" data-dismiss="modal" @click="confirmRejectRegister">ตกลง</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import MemberDetail from './partial/MemberDetailComponent.vue';
    import PaginationComponent from './../sub_components/PaginationComponent';
    export default {
        components: {
            'member-detail': MemberDetail,
            PaginationComponent
        },
        data: function () {
            return {
                listMember: [],
                startDate: null,
                endDate: null,
                keyword: '',
                isShowDetail: false,
                totalPage: 1,
                totalItems: 0,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                reason: '',
                reason_id: 0
            }
        },
        mounted() {
        },
        created() {
            this.buildJquery();
            this.loadList();
            setInterval(() => {
                this.loadList();
            }, 5000);
        },
        computed: {
        },
        methods: {
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            loadList() {
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage
                };
                axios.post(`${this.baseUrl}/admin/api/list-new-member`, params).then(({ data }) => {
                    console.log('list-new-member', data);
                    if (data != null) {
                        const rows = Array.isArray(data.data) ? data.data : [];
                        if (rows.length > 0) {
                            rows.forEach(item => {
                                item.created_at_text = moment(item.created_at).format('DD/MM/YYYY');
                                item.created_at_time_text = moment(item.created_at).format('HH:mm:ss');

                                if (item.register_as === 'personal') {
                                    item.register_as_text = 'บุคคลธรรมดา';
                                } else if (item.register_as === 'juristic_person') {
                                    item.register_as_text = 'นิติบุคคล';
                                }
                            });
                        }
                        this.listMember = rows;
                        this.totalItems = (parseInt(data.total, 10) || 0);
                        this.lastPage = (parseInt(data.totalPage, 10) || 1);

                        this.$nextTick(() => {
                            if (this.$refs.pagination && typeof this.$refs.pagination.bindListPageNo === 'function') {
                                this.$refs.pagination.bindListPageNo();
                            }
                        });
                    }
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            verifyRegister(id) {
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'อนุมัติการสมัครใช่หรือไม่ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/verify-register`, { id }).then(({ data }) => {
                            if (data != null && data.success) {
                                alertbox('บันทึกสำเร็จ');
                                this.loadList();
                            }
                        });
                    }
                });
            },
            rejectRegister(id) {
                this.reason_id = id;
                this.reason = '';
                $('#modal_reject_new_member_reason').modal('show');
            },
            confirmRejectRegister() {
                const vm = this;
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'ปฏิเสธการสมัครใช่หรือไม่ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/api/reject-register`, { id: vm.reason_id, reason: vm.reason }).then(({ data }) => {
                            if (data != null && data.success) {
                                alertbox('บันทึกสำเร็จ');
                                this.loadList();
                            }
                        });
                    }
                });
            },
            buildJquery() {
                const vm = this;
                $(document).ready(function () {
                    $('#wgCalendar').wgCalendar({
                        startDate: new Date(),
                        submitDate: function(data, self) {
                            if (data.isAllDate) {
                                vm.startDate = null;
                                vm.endDate = null;
                            } else {
                                vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                                vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                            }
                            vm.loadList();
                        }
                    });
                });
            },
            showDetail(memberID) {
                this.isShowDetail = true;
                const vm = this;
                this.$nextTick(() => {
                    vm.$refs.memberDetail.showMemberDetail(memberID);
                });
            },
            hideMemberDetail(isLoadList) {
                this.isShowDetail = false;
                if (isLoadList) {
                    this.loadList();
                }
            },
        },
        props: {
            baseUrl: '',
            storagePath: '',
        },
    }
</script>

<style lang="scss" scoped>
    #v_app {
        height: 100%;
    }
    .wrapper-box {
        height: 100%;
    }
</style>




